import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("auth_token");

  // Si l'utilisateur n'est pas connecté, on le redirige vers /auth/login
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // Sinon, on affiche la page demandée
  return children;
};

export default PrivateRoute;
